import { CompanyDto } from 'gleblu-socket-api';

import Company from '../interfaces/Company';

export function fromDto(company: CompanyDto): Company {
  const { uuid, name, vatNumber } = company;
  return {
    uuid,
    name,
    vatNumber,
  };
}

export function toDto(company: Company): CompanyDto {
  const { uuid, name, vatNumber } = company;
  return {
    uuid,
    name,
    vatNumber,
  };
}
